export default function Go_Comments () {
  return (
    <div>
      <h1>Go_Comments </h1>
      <p>Go Comments</p>
    </div>
  );
}